// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__2jfYp","obliqueLineWrap":"membershipbadge_obliqueLineWrap__2I-o8","obliqueLine":"membershipbadge_obliqueLine__3SzNP"};